import { render, staticRenderFns } from "./AllDistroCenterTable.vue?vue&type=template&id=346853ac&scoped=true"
import script from "./AllDistroCenterTable.vue?vue&type=script&lang=js"
export * from "./AllDistroCenterTable.vue?vue&type=script&lang=js"
import style0 from "./AllDistroCenterTable.vue?vue&type=style&index=0&id=346853ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346853ac",
  null
  
)

export default component.exports